module.exports = __webpack_public_path__ + "img/wide.427be63f.jpg";